// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const PriorityFindingsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 25">
    <path
      fill="currentColor"
      d="m18.19 6.28-2.24 2.24a5.79 5.79 0 1 1-.74-.74l2.23-2.24a8.95 8.95 0 1 0 .74.74M15.2 9.27l-2.27 2.27q.15.32.15.68a1.58 1.58 0 1 1-.9-1.42l2.28-2.28a4.74 4.74 0 1 0 .74.74m-3.32 2.6v-.02h-.02a.52.52 0 0 0-.89.37.53.53 0 1 0 .91-.36m9.62.35a10 10 0 1 1-20 0 10 10 0 0 1 20 0"
    />
  </svg>,
  "PriorityFindings",
);
export default PriorityFindingsIcon;
